import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PATHS from '../../routes/Paths';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetInfluencerProfileQuery, useGetSettingsQuery } from '../../services/Api';
import { BASE_URL } from '../../services/ApiEndpoints';
import { logo } from '../../assets/imagesPath';

const ProtectedRoutes = ({ children }) => {

    const auth = useSelector((data) => data?.auth);
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;

    const {
        data: getInfluencerProfile,
        refetch: getInfluencerProfileRefetch,
    } = useGetInfluencerProfileQuery();

    const {
        data: getSettings,
        refetch: getSettingsRefetch,
    } = useGetSettingsQuery();

    const pathsWithoutAuth = [PATHS.signin, PATHS.signup, PATHS.forgotPassword, PATHS.resetPassword, PATHS.home, PATHS.creatorsHome, PATHS.contactus, PATHS.termsConditions, PATHS.privacyPolicy, PATHS.aboutUs, PATHS.influencers, PATHS.influencerSearch, PATHS.savedInfluencers, PATHS.influencerDetail, PATHS.marketplace];

    const influencerPaths = [PATHS.messages, PATHS.influencerSupport, PATHS.influencerProfile, PATHS.influencerPublicProfile, PATHS.editPackages, PATHS.addSocialLinks, PATHS.transactions, PATHS.challangeDetail, PATHS.yourProposals, PATHS.yourJobs, PATHS.viewPitch, PATHS.viewJobDetail, PATHS.jobsDashboard, PATHS.jobInvitations];

    const brandPaths = [PATHS.dashboard, PATHS.challanges, PATHS.addChallange, PATHS.challangeOtherDetail, PATHS.challangePreview, PATHS.challangePayment, PATHS.challangeSuccess, PATHS.proposals, PATHS.brandMessages, PATHS.findInfluencers, PATHS.myNetwork, PATHS.hireInfluencers, PATHS.hiredInfluencers, PATHS.emails, PATHS.reports, PATHS.brandTransactions, PATHS.settings, PATHS.brandSupport, PATHS.viewEmail, PATHS.viewInfluencerDetail, PATHS.brandSavedInfluencers, PATHS.viewContent];

    useEffect(() => {
        const isAllowedPath = pathsWithoutAuth?.includes(pathname);
        if (!auth?.isLoggedIn && !auth?.userDetail && !isAllowedPath) {
            navigate(PATHS.signin);
        };
    }, [auth, pathname]);

    useEffect(() => {
        if (auth?.isLoggedIn && auth?.userDetail && pathname == "/") {
            navigate(auth?.userDetail?.Role == "influencer" ? PATHS.home : PATHS.dashboard);
        };
    }, [auth, pathname]);

    useEffect(() => {
        if (pathname != "/pitch") {
            localStorage.removeItem("activeTab");
        };
    }, [pathname]);

    useEffect(() => {
        const isAllowedPathInfluencers = influencerPaths?.includes(pathname);
        if (auth?.isLoggedIn && auth?.userDetail?.Role == "brand" && isAllowedPathInfluencers) {
            navigate(PATHS.signin);
        };
    }, [auth, pathname]);

    useEffect(() => {
        const isAllowedPathBrands = brandPaths?.includes(pathname);
        if (auth?.isLoggedIn && auth?.userDetail?.Role == "influencer" && isAllowedPathBrands) {
            navigate(PATHS.signin);
        };
    }, [auth, pathname]);

    useEffect(() => {
        getSettingsRefetch();
    }, []);

    useEffect(() => {
        getInfluencerProfileRefetch();
    }, [pathname]);

    // useEffect(() => {
    //     if (!getInfluencerProfile?.data?.user?.FullName && getInfluencerProfile?.data?.user?.Role == "brand") {
    //         navigate(PATHS.signupBasic);
    //     }
    // }, [getInfluencerProfile?.data?.user?.Role == "brand"]);

    useEffect(() => {
        if (!getInfluencerProfile?.data?.user?.FullName && getInfluencerProfile?.data?.user?.Role == "influencer") {
            navigate(PATHS.signupBasic);
        } else if (!getInfluencerProfile?.data?.packages?.length && getInfluencerProfile?.data?.user?.Role == "influencer") {
            navigate(PATHS.signupPackages);
        }
    }, [getInfluencerProfile?.data?.user?.Role == "influencer"]);

    useEffect(() => {
        const logoElements = document.getElementsByClassName("siteLogo");
        const fallbackLogo = logo;

        if (logoElements.length) {
            const logoSrc = getSettings?.data?.Logo
                ? BASE_URL + getSettings.data.Logo
                : fallbackLogo;

            for (let i = 0; i < logoElements.length; i++) {
                logoElements[i].src = logoSrc;
            }
        }
    }, [getSettings?.data, pathname]);

    useEffect(() => {
        const link = document.querySelector("link[rel~='icon']");
        if (!link) {
            const newLink = document.createElement("link");
            newLink.rel = "icon";
            newLink.href = BASE_URL + getSettings?.data?.Favicon;
            document.head.appendChild(newLink);
        } else {
            link.href = BASE_URL + getSettings?.data?.Favicon;
        }
    }, [getSettings?.data, pathname]);

    return <>{children}</>;
};

export default ProtectedRoutes;